export default [{
        name: '首页',
        path: '/',
        icon: require('../assets/menu/shouye.png'),
        classname:'shouye',
        authority: 'Manage Edit'
    },
    {
        name: '内容管理',
        icon: require('../assets/menu/guanli.png'),
        classname:'guanli',
        authority: 'Manage Edit',
        children: [
            {
                name: '内容审核',
                path: '/manage/contentauditCut',
                authority: 'Manage'
            },
        ]
    },
    {
        name: '设置',
        icon: require('../assets/menu/shezhi.png'),
        classname:'shezhi',
        authority: 'Manage Edit',
        children: [{
                name: '账号信息',
                path: '/settings/account',
                authority: 'Manage Edit'
            },
        ]
    }
]



// WEBPACK FOOTER //
// ./src/config/reviewExpert.js